import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { X, UserCircle, Store, ShoppingCart, Package, PhoneCall, LogOut, HomeIcon, EarthIcon } from 'lucide-react';
import { auth } from '../firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import Logo from './images/logo.png';
import ThemeToggleButton from '../themeButton'
import { HomeModernIcon } from '@heroicons/react/24/solid';
const Sidebar = ({ isOpen, setIsOpen, setLoginOpen, setScreen, isAdminRoute }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsOpen(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
      {/* Background Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-primary dark:bg-primary-dark bg-opacity-70 z-30"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <motion.aside
        initial={{ x: '-100%' }}
        animate={{ x: isOpen ? '0%' : '-100%' }}
        transition={{ duration: 0.1 }}
        className="fixed top-0 left-0 w-64 h-full bg-primary dark:bg-primary-dark text-primary-text dark:text-primary-text-dark p-6 shadow-lg shadow-secondary/20 z-40 border-r border-secondary/20"
      >
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-bold text-secondary">
            Menu
          </h3>
          <X
            size={24}
            className="cursor-pointer text-secondary hover:text-primary-text-dark dark:hover:text-primary-text transition-colors"
            onClick={() => setIsOpen(false)}
          />
        </div>

        <div className="flex flex-col items-center text-center mt-6">
          <UserCircle size={64} className="text-secondary" />
          <p className="mt-1">{user ? user.email : 'User not logged in'}</p>
          {!user && (
            <motion.button
              onClick={() => {
                setLoginOpen(true);
                setIsOpen(false);
              }}
              className="mt-2 px-4 py-2 bg-secondary text-primary-text w-full flex items-center justify-center rounded-md hover:bg-secondary/80 transition-colors"
              whileHover={{ scale: 1.05 }}
            >
              Login / Sign Up
            </motion.button>
          )}
        </div>
        <nav className="mt-6">

          <SidebarItem
            icon={Store}
            text="Store"
            onClick={() => {
              setScreen('/shop');
              setIsOpen(false);
            }}
          />
          {!isAdminRoute && (
            <>
              <SidebarItem
                icon={ShoppingCart}
                text="Cart"
                onClick={() => {
                  setScreen('/cart');
                  setIsOpen(false);
                }}
              />
              <SidebarItem
                icon={Package}
                text="Orders"
                onClick={() => {
                  setScreen('/orders');
                  setIsOpen(false);
                }}
              />
            </>
          )}
              <SidebarItem
                icon={EarthIcon}
                text="Homepage"
                onClick={() => {
                  setScreen('/');
                  setIsOpen(false);
                }}
              />
          <SidebarItem
            icon={PhoneCall}
            text="Support"
            onClick={() => {
              setScreen('/Support');
              setIsOpen(false);
            }}
          />
        </nav>

        {user && (
          <motion.button
            onClick={handleLogout}
            className="mt-6 w-full flex items-center justify-center px-4 py-2 bg-secondary text-primary-text rounded-md hover:bg-secondary/80 transition-colors"
            whileHover={{ scale: 1.05 }}
          >
            <LogOut size={18} className="mr-2" /> Logout
          </motion.button>
        )}

        <div className="mt-20">
          <ThemeToggleButton/>
        </div>
      </motion.aside>
    </>
  );
};

const SidebarItem = ({ icon: Icon, text, onClick }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05, backgroundColor: 'rgba(219, 174, 110, 0.2)' }}
      className="flex items-center space-x-3 p-3 mt-2 border-b border-secondary/20 cursor-pointer text-primary-text dark:text-primary-text-dark hover:text-secondary transition-colors"
      onClick={onClick}
    >
      {typeof Icon === 'function' ? <Icon /> : <Icon size={24} className="text-secondary" />}
      <span>{text}</span>
    </motion.div>
  );
};

export default Sidebar;